import Permissions from '@security/permissions';
import PermissionChecker from '@modules/iam/permission-checker';

export class PropertyPermissions {
  constructor(currentUser) {
    const permissionChecker = new PermissionChecker(
      currentUser,
    );

    this.read = permissionChecker.match(
      Permissions.values.propertyRead,
    );
    this.import = permissionChecker.match(
      Permissions.values.propertyImport,
    );
    this.propertyAutocomplete = permissionChecker.match(
      Permissions.values.propertyAutocomplete,
    );
    this.create = permissionChecker.match(
      Permissions.values.propertyCreate,
    );
    this.edit = permissionChecker.match(
      Permissions.values.propertyEdit,
    );
    this.destroy = permissionChecker.match(
      Permissions.values.propertyDestroy,
    );
  }
}
